import * as actions from '@actions';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { Case } from 'vl-common/src/schemas/shared/case';

// returns a three element tuple: the case information, query invalidation function and a loading state
export default function useCase(id: number) {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const ret = useQuery<{
    cases: Case[];
  }>({
    queryKey: ['useCase', id],
    queryFn: () => (id ? dispatch(actions.getCaseDetails(id)) : Promise.resolve(null))
  });
  const cases = ret.data?.cases || [null];

  const invalidateCaseData = () =>
    queryClient.invalidateQueries({
      queryKey: ['useCase', id]
    });

  return [cases[0], invalidateCaseData, ret.isLoading] as const;
}
